import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductInternalNoteRequest,
  ProductInternalNoteResponse,
  ProductInternalNoteUpdateRequest
} from '../models/producto-internal-note.model';

/**
 * Servicio HTTP de notas internas de producto (Incidente #26, INC_CRM_006).
 *
 * Endpoints backend: /api/products/{productId}/internal-notes
 * El businessId lo resuelve el backend desde el JWT (no se envía como parámetro).
 */
@Injectable({
  providedIn: 'root'
})
export class ProductoInternalNoteApiService {
  private readonly apiUrl = `${environment.apiUrl}api/products`;

  constructor(private http: HttpClient) { }

  /** Lista las notas internas del producto (orden cronológico). */
  getInternalNotes(productId: number): Observable<ProductInternalNoteResponse[]> {
    return this.http.get<ProductInternalNoteResponse[]>(`${this.apiUrl}/${productId}/internal-notes`);
  }

  /** Crea una nota interna. El autor se toma del JWT en el backend. */
  createInternalNote(productId: number, req: ProductInternalNoteRequest): Observable<ProductInternalNoteResponse> {
    return this.http.post<ProductInternalNoteResponse>(`${this.apiUrl}/${productId}/internal-notes`, req);
  }

  /** Edita una nota interna existente (solo el autor). */
  updateInternalNote(productId: number, noteId: number, req: ProductInternalNoteUpdateRequest): Observable<ProductInternalNoteResponse> {
    return this.http.put<ProductInternalNoteResponse>(`${this.apiUrl}/${productId}/internal-notes/${noteId}`, req);
  }

  /** Elimina una nota interna (solo el autor). */
  deleteInternalNote(productId: number, noteId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${productId}/internal-notes/${noteId}`);
  }
}
